import CreditCardShape from '../definitions/CreditCardShape';


/**
 * Extract the important credit card properties for inclusion in our __rhAnalytics object.
 * The function’s argument should match a CreditCardShape.
 * @param {CreditCardShape} cardInfo - the credit card
 * @param {string} cardInfo.id - the card’s id
 * @param {string} cardInfo.primaryId - the card’s primaryId
 * @param {string} cardInfo.name - the card’s name
 * @param {string} cardInfo.slug - the card’s slug
 * @param {string} cardInfo.bank - the card’s bank
 * @param {string} cardInfo.network - the card’s network
 * @param {string} cardInfo.productType - the card’s productType
 * @param {string} cardInfo.displayType - the card’s displayType
 * @param {string} cardInfo.cardImageURL - the card’s cardImageURL
 * @param {number} cardInfo.rank - the card’s rank
 * @param {boolean} cardInfo.isMonetized - the card’s isMonetized
 * @param {boolean} cardInfo.isSponsored - the card’s isSponsored
 * @param {boolean} cardInfo.netSubsequentYearValue - the card’s netSubsequentYearValue
 * @param {boolean} cardInfo.signUpBonusDollars - the card’s signUpBonusDollars
 * @param {string} cardInfo.detailsURL - the card’s detailsURL
 * @param {string} cardInfo.applyRedirectURL - the card’s applyRedirectURL
 * @param {number} cardInfo.purchaseInterest - the card’s purchaseInterest
 * @param {number} cardInfo.balanceTransferInterest - the card’s balanceTransferInterest
 * @param {number} cardInfo.cashAdvanceInterest - the card’s cashAdvanceInterest
 * @param {string} cardInfo.approvalLikelihood - the card’s approvalLikelihood
 * @param {number} cardInfo.approvalLikelihoodScore - the card’s approvalLikelihoodScore
 * @param {object} cardInfo.giftCardOffer - the card’s giftCardOffer
 * @param {number} cardInfo.minimumDeposit - the card’s minimumDeposit
 * @param {number} cardInfo.annualFee - the card’s annualFee
 * @param {string} cardInfo.bestUsedFor - the card’s bestUsedFor
 * @param {number} cardInfo.balanceTransferPromoInterest - the card’s balanceTransferPromoInterest
 * @param {number} cardInfo.balanceTransferPromoMonths - the card’s balanceTransferPromoMonths
 * @param {object} cardInfo.cardTypes - the card’s cardTypes
 * @param {object} cardInfo.rewardTypes - the card’s rewardTypes
 * @param {string} cardInfo.userCategory - the card’s userCategory
 * @param {object} cardInfo.ratehubReview - the card’s ratehubReview
 * @param {number} cardInfo.ratehubReview.rating - the card’s ratehubReview rating
 * @returns {object} - the __rhAnalytics object
 */
export default function extractRhAnalyticsFromCreditCard(cardInfo) {
    return {
        id: cardInfo.id,
        primaryId: cardInfo.primaryId,
        name: cardInfo.name,
        slug: cardInfo.slug,
        bank: cardInfo.bank,
        network: cardInfo.network,

        productType: cardInfo.productType,
        displayType: cardInfo.displayType,

        cardImageURL: cardInfo.cardImageURL,

        rank: cardInfo.rank,

        isMonetized: cardInfo.isMonetized,
        isSponsored: cardInfo.isSponsored,

        netSubsequentYearValue: cardInfo.netSubsequentYearValue,
        signUpBonusDollars: cardInfo.signUpBonusDollars,

        detailsURL: cardInfo.detailsURL,
        applyRedirectURL: cardInfo.applyRedirectURL,

        purchaseInterest: cardInfo.purchaseInterest,
        balanceTransferInterest: cardInfo.balanceTransferInterest,
        cashAdvanceInterest: cardInfo.cashAdvanceInterest,

        approvalLikelihood: cardInfo.approvalLikelihood,
        approvalLikelihoodScore: cardInfo.approvalLikelihoodScore,

        giftCardOffer: cardInfo.giftCardOffer,

        minimumDeposit: cardInfo.minimumDeposit,
        annualFee: cardInfo.annualFee,
        bestUsedFor: cardInfo.bestUsedFor,

        balanceTransferPromoInterest: cardInfo.balanceTransferPromoInterest,
        balanceTransferPromoMonths: cardInfo.balanceTransferPromoMonths,

        cardTypes: cardInfo.cardTypes,

        rewardTypes: cardInfo.rewardTypes,
        userCategory: cardInfo.userCategory,

        // for analytics, we only care about the `rating`, and leave ratehubReview undefined if there is no rating
        ...(cardInfo.ratehubReview && {
            ratehubReview: {
                rating: cardInfo.ratehubReview.rating,
            },
        }),
    };
}
